import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { StatusPill } from '@/modules/SuggestedFaq';

export const StyledContainer = styled.div`
  padding: 1.5rem;
  max-width: 47.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

export const StyledLoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
`;

export const StyledTitlePill = styled(StatusPill)`
  margin-left: 0.75rem;
  vertical-align: middle;
`;

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  background-color: ${COLORS.WHITE};
  border: 1px solid ${COLORS.COLOR_BORDER_SECONDARY};
  border-radius: 0.875rem;
  padding: 1.5rem;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
`;

export const StyledLockBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: ${COLORS.GRAY_7};
  border: 1px solid ${COLORS.COLOR_BORDER_SECONDARY};
  border-radius: 0.625rem;
  padding: 0.6875rem 0.875rem;
  ${pickThemeFontStyles('13', '18')}
  color: ${COLORS.TEXT_HINT};

  strong {
    font-weight: ${({ theme }) => theme?.token?.fontWeightStrong ?? 700};
  }
`;

export const StyledActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
`;
